// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__s5lp0","hiddenSide":"layout_hiddenSide__BSmUP","layout__inner":"layout_layout__inner__CW2cT","container":"layout_container__dnKos"};